import { connectScreenCloud } from "@screencloud/apps-sdk";
import { StudioGraphQLClient } from "@screencloud/studio-graphql-client";

let token = null;
const SERVICES_URL = "https://services.cetvnow.network/screencloud";
const CLIENT = "screencloud";
const VERSION = "1.0.5";
const SC_API_TOKEN = "a36c1ea8-f75a-49e4-b512-31d348c34e70:391a7c63d336e3b71e7bfcad04267d21";
const SC_API_URL = "https://graphql.us.screencloud.com/graphql";

function checkConfig(ext_id) {
  const config = JSON.parse(localStorage.getItem("config"));
  console.log("config", config);
  if (config && config.adServerURL && config.screenId && config.locationId) {
    console.log("config exists");
    window.location.href = `/player/index.html`;
  } else {
    console.log("config does not exist");
    getConfig(ext_id);
  }
}

//get the config
function getConfig(ext_id) {
  let url = `${SERVICES_URL}/config?ext_id=${ext_id}&client=${CLIENT}&version=${VERSION}`;

  fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }

      //if the error is 404, then let's create a screen using data from ScreenClound,
      if (response.status === 404) {
        console.log("Screen not found. Creating screen...");
        document.getElementById("message").innerText = "Screen not found.";
        return;
      }

      document.getElementById("message").innerText = "Error getting configuration.";

      throw new Error("Error getting configuration.");
    })
    .then((data) => {
      if (!data) {
        console.log("Creating screen...");
        //getScreenData(ext_id);
        return;
      }
      data.token = token;
      document.getElementById("message").innerText = "Done. Please wait.";
      localStorage.setItem("config", JSON.stringify(data));
      window.location.href = "/player/index.html";
    })
    .catch((error) => {
      console.log("error", error);
      document.getElementById("message").innerText = "Error getting configuration.";
    });
}

async function createScreen(ext_id, data) {
  console.log("Creating screen...");
  console.log("data", data);

  const screen = {
    screen_name: data.name,
    ext_id: ext_id,
    space_name: data.spaceBySpaceId.name,
  };

  console.log("screen", screen);

  let url = `${SERVICES_URL}/screens`;
  const reponse = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(screen),
  });

  console.log("reponse", reponse);
  if (reponse.ok) {
    console.log("Screen created");
    document.getElementById("message").innerText = "Done. Please wait.";
    getConfig(ext_id);
  }
}

//user ScreenCloud API to create a screen
//this function will be called if the config is not found
async function getScreenData(ext_id) {
  //before we create the screen, we need toget some data from ScreenCloud
  //GraphQL API

  const client = new StudioGraphQLClient({
    endpoint: SC_API_URL,
    token: SC_API_TOKEN,
  });

  let result = await client.request(
    `
      query {
        screenById(id: "${ext_id}"){
            name,
            additionalDeviceSettings,
            additionalPlayerSettings,
            deviceIpAddress,
            deviceInfo,
            spaceBySpaceId{
              name
            }
          }
      }
      `,
  );

  console.log("result", result);
  createScreen(ext_id, result.screenById);
}

//start function to connect to ScreenCloud
async function start() {
  console.log("Let's get this started");

  //let's see if there is a screen ID in the URL, if not, redirect the user to cetvnow.com
  const screenId = new URLSearchParams(window.location.search).get("id");
  if (!screenId) {
    window.location.href = "https://cetvnow.com";
    return;
  }

  const ext_id = "100000000";
  //const ext_id = "762b47d3-483b-4f22-adc2-391dccd900e9";
  document.getElementById("version").innerText = `Checking for the correct screen...`;
  if (!ext_id) {
    console.log("No screen ID found");

    document.getElementById("message").innerText = "ScreenCloud ID not found.";
    return;
  }

  //let clear the config if there is one and start over
  localStorage.removeItem("config");

  //before checking config, let's sleep for a min so the player version can be checked
  await new Promise((resolve) => setTimeout(resolve, 2000));

  checkConfig(ext_id);
}

start();
